var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-authenticated',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumb}}),_c('h2',[_vm._v(_vm._s(_vm.$t('carriers.carriers')))]),_c('carriers-table-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }